import styled from "styled-components";

/**
 * Wrapper do InputField (Desktop)
 * Define o layout geral do campo de entrada e posiciona o botão de limpeza.
 */
export const InputFieldWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;

  & > div {
    width: 100%;
  }

  input {
    min-width: 0;
    padding-right: ${({ theme }) => theme.spacing(8)};
    text-overflow: ellipsis;
  }
`;

/**
 * Botão de limpar (Desktop)
 * Posicionado à direita do campo, com estilos dinâmicos.
 */
export const ClearButton = styled.button`
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.mediumBlue};
  font-size: ${({ theme }) => theme.fontSizes.md};
  right: ${({ theme }) => theme.spacing(2.5)};
  transition: color 0.3s ease-in-out;
  align-items: center;
  position: absolute;
  display: flex;
  border: none;
  cursor: pointer;

  & * {
    cursor: inherit;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.vividBlue};
  }

  &:focus {
    outline: none;
    color: ${({ theme }) => theme.colors.darkBlue};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.disabledGray};
    cursor: not-allowed;
  }
`;
